import axios from 'axios'

// ACTION TYPES
const name = 'data'
export const actionTypes = {
  LOAD_PERFORMANCE: `${name}:load_performance`,
  SET_PERF_START_DATE: `${name}:set_perf_start_date`,
  SET_PERF_END_DATE: `${name}:set_perf_end_date`,
  SET_ENTITY: `${name}:set_entity`,
  SET_PERIOD: `${name}:set_period`,
  SET_RANGE: `${name}:set_range`,
  SET_RANGE_OPTIONS: `${name}:set_range_options`,
  SET_RANGE_OPTIONS2: `${name}:set_range_options2`,
  SET_EARNINGS_TYPE: `${name}: set_earnings_type`,
  SET_GROWTH_TYPE: `${name}: set_growth_type`,
  SET_EARNINGS_PERIOD: `${name}: set_earnings_period`,
  SET_SELECTED_CHARS: `${name}: set_selected_chars`,
  SET_CONSTITUENT_NUMBER: `${name}: set_constituent_number`,
  FILTER_PERIOD_DATA: `${name}:filter_period_data`,
  FILTER_RANGE_DATA: `${name}:filter_range_data`,
  RESET_LOAD_STATUS: `${name}:reset_load_status`
}

// ACTIONS
export function loadPerformance() {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.RESET_LOAD_STATUS, value: false })
    var ticker = ''
    const date = getState().params.date
    const initialTicker = getState().params.ticker
    let selectedTicker = getState().data.selectedEntityOption[0]

    if (selectedTicker) {
      let x = selectedTicker.split(' - ')
      ticker = x[0]
    } else {
      ticker = initialTicker
    }

    let url = `${process.env.REACT_APP_API_URL}/data`
    const request = {
      method: 'GET',
      url: url,
      params: {
        divisionId: getState().params.divisionId,
        wtRegion: getState().params.wtRegion,
        isoCode: getState().params.isoCode,
        isFP: getState().params.isFP,

        ticker: ticker,
        date: date
      }
    }
    return axios(request)
      .then(response => {
        console.log('REQUEST', request)
        console.log('RESPONSE', response)
        dispatch({ type: actionTypes.LOAD_PERFORMANCE, value: response.data })
        dispatch({ type: actionTypes.RESET_LOAD_STATUS, value: true })
      })
      .catch(error => {
        console.error(error)
      })
  }
}

export function setEntity(entity) {
  return dispatch => {
    const selected = entity.value
    dispatch({ type: actionTypes.SET_ENTITY, value: selected })
    dispatch(loadPerformance())
  }
}

export function setPeriod(period) {
  return dispatch => {
    const selected = period.value
    const type = 'period_' + selected
    dispatch({ type: actionTypes.SET_PERIOD, value: selected })
    dispatch({ type: actionTypes.SET_RANGE_OPTIONS, value: type })
  }
}

export function setRange(range) {
  return dispatch => {
    const selected = range.value
    const type = 'range_' + selected
    dispatch({ type: actionTypes.SET_RANGE, value: selected })
    dispatch({ type: actionTypes.SET_RANGE_OPTIONS, value: type })
  }
}
export function setEarningsType(value) {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.SET_EARNINGS_TYPE, payload: value })
  }
}

export function setGrowthType(value) {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.SET_GROWTH_TYPE, payload: value })
  }
}

export function setConstituentNumber(value) {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.SET_CONSTITUENT_NUMBER, payload: value })
  }
}

/* sets list of chars to display series chart data */
export function setSelectedChars(value) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_SELECTED_CHARS, payload: value })
  }
}
// export function setConstituentNumber(value) {
//   return (dispatch, getState) => {
//     dispatch({ type: actionTypes.SET_CONSTITUENT_NUMBER, payload: value })
//   }
// }



// WEBPACK FOOTER //
// ./src/actions/data.js